var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseFilterBar',{attrs:{"search-placeholder":_vm.searchPlaceholder,"search":_vm.search,"filters":_vm.filters,"values":_vm.filterValues,"show-search":_vm.showSearch},on:{"filter-change":_vm.handleFilterChange,"submit":_vm.handleSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }